export default __webpack_public_path__ + "static/media/cart1.a860a22c.svg";